import { render, staticRenderFns } from "./GeneralInfos.vue?vue&type=template&id=10fc3c26&scoped=true&"
import script from "./GeneralInfos.vue?vue&type=script&lang=js&"
export * from "./GeneralInfos.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfos.vue?vue&type=style&index=0&id=10fc3c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc3c26",
  null
  
)

component.options.__file = "GeneralInfos.vue"
export default component.exports